import { Button } from 'components';
import styled from 'styled-components';
import { colors } from 'styles/colors';

export const BigNumber = styled.div<{comingSoon?: boolean}>`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  opacity: ${({ comingSoon }) => (comingSoon ? 0.6 : 1)};

  @media (max-width: 768px) {
    & > div:nth-child(1) {
      flex: 1;
    }
  }
`;

export const BigNumberHeader = styled.h4<{disabledColor?: boolean}>`
  margin: 0;
  color: ${({ disabledColor }) => (disabledColor ? colors.text['disabled-300'] : colors.text['main-900'])};
  font-weight: 700;
  font-size: 32px;
  line-height: 130%;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const BigNumberCardContainer = styled.div<{ loading?: boolean }>`
  position: relative;
  width: auto;
  height: 104px;
  display: flex;
  align-items: start;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &:not(:last-child) {
    border-right: 1px solid ${colors.stroke['soft-200']};

    & > div > div {
      padding-right: 16px;
    }
  }

  @media (max-width: 768px) {
    height: 136px;
    justify-content: center;
    width: 100%;
    padding: 16px;

    ${({ loading }) => (loading ? `
      gap: 8px;
    ` : '')}

    & > div {
      width: ${({ loading }) => (loading ? 'auto' : '80%')};
      flex: unset;
    }

    & > div > div:nth-child(1) {
      justify-content: start;
    }

    &:not(:last-child) {
      border-right: 0;
      border-bottom: 1px solid ${colors.stroke['soft-200']};

      & > div > div {
        padding-right: 0;
      }
    }
  }
`;

export const BigNumberIcon = styled.div`
  width: 32px;
  height: 32px;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.brand.primary.lighterAlt};
`;

export const Description = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;

  h5 {
    font-weight: 600;
    font-size: 12px;
    line-height: 180%;
    margin: 0;
    color: ${colors.text['main-900']};
    white-space: nowrap;
  }

  & > .tooltip-bignumber {
    max-width: 800px;
    opacity: 1 !important;
  }


  @media (max-width: 768px) {
    & > .tooltip-bignumber {
      max-width: 96vw;
    }
  }
`;

export const SubDescription = styled.div<{ comingSoon?: boolean; breakLine?: boolean }>`
  max-width: ${({ breakLine }) => (breakLine ? '224px' : 'auto')};
  display: ${({ breakLine }) => (breakLine ? 'block' : 'flex')};
  gap: 2px;
  opacity: ${({ comingSoon }) => (comingSoon ? 0.6 : 1)};

  & > span {
    font-size: 12px;
    line-height: 180%;
    color: ${colors.text['soft-400']};
    white-space: ${({ breakLine }) => (breakLine ? 'normal' : 'nowrap')};
  }

  & > span:nth-child(1) {
    font-weight: 700;
  }

  & > span:nth-child(2) {
    font-weight: 400;
    padding-left: ${({ breakLine }) => (breakLine ? '2px' : '0')};
  }
`;

export const DetailsButton = styled(Button)`
  width: 92px;
  height: 25px;
  margin-top: 8px;
  white-space: nowrap;

  margin-left: auto;
`;

export const DisabledDetailsText = styled.span`
  width: 92px;
  height: 25px;
  margin-top: 8px;
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  line-height: 25px;
  color: ${colors.brand.primary.base};
  text-align: center;
  cursor: default;
  text-transform: none;
  white-space: nowrap;
`;

export const IndicatorContainer = styled.div<{color: string }>`
  width: 12px;
  height: 12px;
  margin: auto 0;
  border-radius: 9999px;
  background-color: ${({ color }) => color};
  flex-shrink: 0;
`;

export const ComingSoonBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  margin-top: 8px;
  margin-left: auto;
  border: 1px solid ${colors.brand.primary.base};
  border-radius: 4px;
  background-color: transparent;
  color: ${colors.brand.primary.base};
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  width: 92px;
  height: 25px;
  opacity: 1;
  text-transform: uppercase;
`;

export const BetaContent = styled.div`
  background: #363BC4;
  color: white;
  font-weight: 700;
  font-size: 10px;
  height: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 8px;
  text-align: center;
  vertical-align: middle;
  line-height: 20px;
  flex-shrink: 0;
  padding: 0 8px;
`;
